import React, { useState } from 'react';

const trackEvent = (eventName, params = {}) => {
  if (window.gtag) {
    window.gtag('event', eventName, { app: 'find_my_lead_magnet', ...params });
  }
};

function EmailCapture({ onSubmit, prefillEmail = '' }) {
  const [email, setEmail] = useState(prefillEmail);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!isValidEmail(email)) {
      alert('Please enter a valid email address');
      return;
    }

    trackEvent('email_captured', { source: 'quiz_gate' });
    setIsSubmitting(true);
    await onSubmit(email);
    setIsSubmitting(false);
  };

  const isValidEmail = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
  };

  return (
    <div className="email-container">
      <h2>{prefillEmail ? 'Looking good!' : 'Almost There!'}</h2>
      <p>{prefillEmail
        ? 'We already have your email -- just confirm it below and we\'ll show your results.'
        : 'Enter your email to see your personalized lead magnet recommendations'
      }</p>
      
      <form onSubmit={handleSubmit} className="email-form">
        <input
          type="email"
          className="email-input"
          placeholder="your@email.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button 
          type="submit" 
          className="btn btn-primary"
          disabled={isSubmitting}
        >
          {isSubmitting ? 'Getting Your Recommendations...' : 'Show Me My Results'}
        </button>
      </form>

      <p style={{ marginTop: '1.5rem', fontSize: '0.9rem', color: '#878585' }}>
       
      </p>
    </div>
  );
}

export default EmailCapture;
